import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoryFinanceApi = {
    getLaboratoryFinanceByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetLaboratoryFinanceByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryFinanceByLaboratoryId = new Dtos.GetLaboratoryFinanceByLaboratoryId();
        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryFinanceByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryFinanceById: (id: number): Observable<Dtos.GetLaboratoryFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryFinanceById = new Dtos.GetLaboratoryFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratoryFinance: (laboratoryFinance: Dtos.LaboratoryFinance): Observable<Dtos.SetLaboratoryFinanceResponse> => {

        let request: Dtos.SetLaboratoryFinance = new Dtos.SetLaboratoryFinance();

        request.laboratoryFinance = laboratoryFinance;

        // send request
        const response: Promise<Dtos.SetLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createLaboratoryFinance: (laboratoryId: number): Observable<Dtos.CreateLaboratoryFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratoryFinance = new Dtos.CreateLaboratoryFinance();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratoryFinance: (laboratoryFinance: Dtos.LaboratoryFinance): Observable<Dtos.ValidateLaboratoryFinanceResponse> => {

        let request: Dtos.ValidateLaboratoryFinance = new Dtos.ValidateLaboratoryFinance();

        request.laboratoryFinance = laboratoryFinance;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}